(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
  const outputListItem = document.querySelector('#hub-blogs');
  if (outputListItem) {
    let slug = outputListItem.dataset.guideSlug;
    const HUB_URL = 'https://hub.betterbedcompany.co.uk/graphql-ahgukwylbemipbrqwvnrrakpq';

    fetch(HUB_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
                  query getPosts {
                    posts(where: {categoryName: "${slug}"}, first: 3) {
                      nodes {
                        featuredImage {
                          node {
                            srcSet(size: KIDZZZ_IMAGE)
                            sizes(size: KIDZZZ_IMAGE)
                            altText
                            mediaItemUrl
                            mediaDetails {
                              sizes(include: KIDZZZ_IMAGE) {
                                width
                                height
                                sourceUrl
                              }
                            }
                          }
                        }
                        title
                        link
                        excerpt
                      }
                    }
                  }
            `,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let articles = result.data.posts.nodes;
        articles.forEach((article) => {
          let {
            featuredImage: {
              node: { altText, mediaDetails, mediaItemUrl, sizes, srcSet },
            },
            link,
            title,
            excerpt,
          } = article;

          let outputEl = `
            <div class="article-card-wrapper swiper-slide card-wrapper underline-links-hover">
                <div class="card article-card card--standard card--media" style="--ratio-percent: 75.01875468867217%;">
                  <div class="card__inner  color-scheme-2 gradient ratio" style="--ratio-percent: 75.01875468867217%;">
                    <div class="article-card__image-wrapper card__media">
                        <div class="article-card__image media media--hover-effect">

                          <img src="${mediaDetails.sizes[0].sourceUrl}" sizes="${sizes}" alt="${altText}" class="motion-reduce" loading="lazy" width="${mediaDetails.sizes[0].width}" height="${mediaDetails.sizes[0].height}">

                        </div>
                    </div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading">
                          <a href="${link}" class="full-unstyled-link h4">
                            ${title}
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading h4">
                        <a href="${link}" class="full-unstyled-link h4">
                          ${title}
                        </a>
                      </h3>
                      ${excerpt}
                      <span class="dummy-link-text body-accent">Learn More<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44339 0.8519C8.79181 0.424652 9.39827 0.380246 9.79789 0.752717L15.6709 6.22642C15.8799 6.42129 16 6.70345 16 6.99999C16 7.29667 15.8799 7.5787 15.6709 7.77356L9.79789 13.2472C9.39827 13.6197 8.79181 13.5754 8.44339 13.1482C8.09498 12.7208 8.13657 12.0726 8.53619 11.7001L12.478 8.02631H0.96C0.429811 8.02631 0 7.56679 0 6.99999C0 6.43319 0.429811 5.97368 0.96 5.97368H12.478L8.53619 2.29993C8.13657 1.92746 8.09498 1.27915 8.44339 0.8519Z" fill="black"></path>
            </svg>
            </span>
                    </div>

                  </div>
                </div>
              </div>
          `;
          outputListItem.insertAdjacentHTML('beforeend', outputEl);
        });
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this?.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  //handle search duplication
  const searchToggleText = document.querySelector('.searchbar-toggle .search-placeholder');
  const searchField = document.querySelector('#Search-In-Modal');

  searchField.addEventListener('input', () => {
    if (searchField.value.length > 2) {
      searchToggleText.innerHTML = searchField.value;
    } else {
      searchToggleText.innerHTML = 'Search for beds';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const outputListItem = document.querySelector('#guide-article');
  let slugs = new URL(outputListItem.dataset.guideSlug).pathname.match(/[^\/]+/g);
  let slug = slugs[slugs.length - 1];
  const HUB_URL = 'https://hub.betterbedcompany.co.uk/graphql-ahgukwylbemipbrqwvnrrakpq';

  fetch(HUB_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
                  query getPosts {
                    post(id: "${slug}", idType: SLUG) {
                      featuredImage {
                        node {
                          srcSet(size: KIDZZZ_IMAGE)
                          sizes(size: KIDZZZ_IMAGE)
                          altText
                          mediaItemUrl
                          mediaDetails {
                            sizes(include: KIDZZZ_IMAGE) {
                              width
                              height
                              sourceUrl
                            }
                          }
                        }
                      }
                      title
                      link
                    }
                  }
            `,
    }),
  })
    .then((res) => res.json())
    .then((result) => {
      let article = result.data.post;
      let {
        featuredImage: {
          node: { altText, mediaDetails, mediaItemUrl, sizes, srcSet },
        },
        link,
        title,
      } = article;

      let outputEl = `
        <div class="article-card-wrapper card-wrapper underline-links-hover">
            <div class="card article-card card--standard card--media" style="--ratio-percent: 75.01875468867217%;">
              <div class="card__inner  color-scheme-2 gradient ratio" style="--ratio-percent: 75.01875468867217%;">
                <div class="article-card__image-wrapper card__media">
                    <div class="article-card__image media media--hover-effect">

                      <img src="${mediaDetails.sizes[0].sourceUrl}" sizes="${sizes}" alt="${altText}" class="motion-reduce" loading="lazy" width="${mediaDetails.sizes[0].width}" height="${mediaDetails.sizes[0].height}">

                    </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading">
                      <a href="${link}" class="full-unstyled-link h4">
                        ${title}
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"><p class="article-tag body-accent">
                      Ultimate Guide
                    </p><h3 class="card__heading h4">
                    <a href="${link}" class="full-unstyled-link h4">
                      ${title}
                    </a>
                  </h3><span class="dummy-link-text body-accent">Learn More<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44339 0.8519C8.79181 0.424652 9.39827 0.380246 9.79789 0.752717L15.6709 6.22642C15.8799 6.42129 16 6.70345 16 6.99999C16 7.29667 15.8799 7.5787 15.6709 7.77356L9.79789 13.2472C9.39827 13.6197 8.79181 13.5754 8.44339 13.1482C8.09498 12.7208 8.13657 12.0726 8.53619 11.7001L12.478 8.02631H0.96C0.429811 8.02631 0 7.56679 0 6.99999C0 6.43319 0.429811 5.97368 0.96 5.97368H12.478L8.53619 2.29993C8.13657 1.92746 8.09498 1.27915 8.44339 0.8519Z" fill="black"></path>
        </svg>
        </span>
                </div></div>
            </div>
          </div>
      `;
      outputListItem.insertAdjacentHTML('beforeend', outputEl);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const HUB_URL = 'https://hub.betterbedcompany.co.uk/graphql-ahgukwylbemipbrqwvnrrakpq';
  const outputListItem = document.querySelector('#guide-article');
  fetch(HUB_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
                  query getPosts {
                    post(id: "${outputListItem.dataset.guideSlug}", idType: SLUG) {
                      featuredImage {
                        node {
                          srcSet(size: KIDZZZ_IMAGE)
                          sizes(size: KIDZZZ_IMAGE)
                          altText
                          mediaItemUrl
                          mediaDetails {
                            sizes(include: KIDZZZ_IMAGE) {
                              width
                              height
                              sourceUrl
                            }
                          }
                        }
                      }
                      title
                      link
                    }
                  }
            `,
    }),
  })
    .then((res) => res.json())
    .then((result) => {
      let article = result.data.post;
      let {
        featuredImage: {
          node: { altText, mediaDetails, sizes, srcSet },
        },
        link,
        title,
      } = article;

      let outputEl = `
        <div class="article-card-wrapper card-wrapper underline-links-hover">
            <div class="card article-card card--standard card--media" style="--ratio-percent: 75.01875468867217%;">
              <div class="card__inner  color-scheme-2 gradient ratio" style="--ratio-percent: 75.01875468867217%;">
                <div class="article-card__image-wrapper card__media">
                    <div class="article-card__image media media--hover-effect">

                      <img src="${mediaDetails.sizes[0].sourceUrl}" sizes="${sizes}" alt="${altText}" class="motion-reduce" loading="lazy" width="${mediaDetails.sizes[0].width}" height="${mediaDetails.sizes[0].height}">

                    </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading">
                      <a href="${link}" class="full-unstyled-link h4">
                        ${title}
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"><p class="article-tag body-accent">
                      Ultimate Guide
                    </p><h3 class="card__heading h4">
                    <a href="${link}" class="full-unstyled-link h4">
                      ${title}
                    </a>
                  </h3><span class="dummy-link-text body-accent">Learn More<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44339 0.8519C8.79181 0.424652 9.39827 0.380246 9.79789 0.752717L15.6709 6.22642C15.8799 6.42129 16 6.70345 16 6.99999C16 7.29667 15.8799 7.5787 15.6709 7.77356L9.79789 13.2472C9.39827 13.6197 8.79181 13.5754 8.44339 13.1482C8.09498 12.7208 8.13657 12.0726 8.53619 11.7001L12.478 8.02631H0.96C0.429811 8.02631 0 7.56679 0 6.99999C0 6.43319 0.429811 5.97368 0.96 5.97368H12.478L8.53619 2.29993C8.13657 1.92746 8.09498 1.27915 8.44339 0.8519Z" fill="black"></path>
        </svg>
        </span>
                </div></div>
            </div>
          </div>
      `;
      outputListItem.insertAdjacentHTML('beforeend', outputEl);
      console.log(article);
    });

  } catch(e) { console.error(e); }
})();
})();
